import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

export const helpers = createMultiStyleConfigHelpers([
  'textBaseStyle',
  'balanceBoosterAppliedStyle',
])

export const PriceBreakdownCollectedAviosAmount = helpers.defineMultiStyleConfig({
  baseStyle: helpers.definePartsStyle({
    textBaseStyle: {
      display: 'inline-block',
      p: 1,
      lineHeight: 1,
    },
  }),
})
